import { PropsWithChildren } from 'react';

const H3 = (props: PropsWithChildren<any>) => <h3 className={'ds-h3'} {...props}>{props.children}</h3>;

export default H3;